module.exports = __webpack_public_path__ + "img/stock_icon.16af7818.svg";